var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, Unique, UpdateDateColumn } from 'typeorm';
import { getLongTextEntityType } from '@/common/config';
let TransactionIntention = class TransactionIntention {
    id;
    msafeAddress;
    sequenceNumber;
    application; // Transaction build app name
    txType; // Transaction type - E.g. assets
    txSubType; // Transaction subType - E.g. coin_transfer
    data;
    processed; // If the intention is process and stored in history
    status; // intention build status: 'SUCCESS' | 'FAILED' | 'NEW';
    statusRemark; // Failed message if status == 'failed'
    creator;
    updatedAt;
    createdAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], TransactionIntention.prototype, "id", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], TransactionIntention.prototype, "msafeAddress", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], TransactionIntention.prototype, "sequenceNumber", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], TransactionIntention.prototype, "application", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], TransactionIntention.prototype, "txType", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], TransactionIntention.prototype, "txSubType", void 0);
__decorate([
    Column(getLongTextEntityType()),
    __metadata("design:type", String)
], TransactionIntention.prototype, "data", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], TransactionIntention.prototype, "processed", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], TransactionIntention.prototype, "status", void 0);
__decorate([
    Column(getLongTextEntityType(), { nullable: true }),
    __metadata("design:type", String)
], TransactionIntention.prototype, "statusRemark", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], TransactionIntention.prototype, "creator", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], TransactionIntention.prototype, "updatedAt", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], TransactionIntention.prototype, "createdAt", void 0);
TransactionIntention = __decorate([
    Entity({ name: 'transaction_intention' }),
    Unique(['msafeAddress', 'sequenceNumber'])
], TransactionIntention);
export { TransactionIntention };
//# sourceMappingURL=module.js.map